import { createStyles, Theme } from '@material-ui/core';

export default ({ spacing: { unit } }: Theme) =>
  createStyles({
    expansionPanel: {
      marginBottom: unit * 2,
    },
  });
